var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTriangles = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 68,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 26,
  x: 58.385,
  y: 31,
  fill: "#FC3C3C",
  rx: 1,
  transform: "rotate(45 58.385 31)"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 22,
  x: 63.556,
  fill: "#FC3C3C",
  rx: 1,
  transform: "rotate(45 63.556 0)"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  x: 28.284,
  y: 0.143,
  fill: "#FC3C3C",
  rx: 2,
  transform: "rotate(45 28.284 .143)"
})));
export default SvgTriangles;